const HEADING_LEVEL: Record<string, string> = {
  one: "1",
  two: "2",
  three: "3",
  four: "4",
  five: "5",
  six: "6",
};

function getBlockId(element: {
  data?: { id?: string; dataId?: string };
  id?: string;
}): string | undefined {
  const data = element?.data || {};
  const id = data.id || data.dataId || element?.id;
  return typeof id === "string" && id.length > 0 ? id : undefined;
}

function isSpotlightBlock(type: string | undefined): boolean {
  if (!type) return false;
  const normalized = type.toLowerCase();

  if (/^paragraph(-|$)/.test(normalized)) {
    return true;
  }

  if (/^h[1-6]$/.test(normalized)) {
    return true;
  }

  const headingMatch = normalized.match(/^heading-?(.+)$/);
  if (headingMatch) {
    const token = headingMatch[1];
    return Boolean(HEADING_LEVEL[token] ?? (/^\d$/.test(token) ? token : null));
  }

  return false;
}

export default function SpotlightBlockIds() {
  const plugin = (editor: unknown) => editor;

  plugin.renderElement = ({ element, attributes }: any) => {
    const blockId = getBlockId(element);
    if (!blockId || !attributes || !isSpotlightBlock(element?.type)) {
      return undefined;
    }

    attributes.id = blockId;
    attributes["data-id"] = blockId;
    return undefined;
  };

  return plugin;
}
